import LinearProgress from "@mui/joy/LinearProgress";
import { RightPaneBackButton } from "../../../components/right_pane_back_button";
import { RightPaneFrame } from "../../../components/right_pane_frame";
import { RightPaneTitle } from "../../../components/right_pane_title";
import { useEffect, useState } from "react";
import Input from "@mui/joy/Input";
import Button from "@mui/joy/Button";
import { Vendor } from "../../../services/api/__generated__/backend_gateway-types";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Typography from "@mui/joy/Typography";
import Textarea from "@mui/joy/Textarea";

export const PoDetailsEditVendorComponent = (props: {
  loading: boolean;
  navigateBack: () => void;
  vendor: Vendor | null;
  setVendor: (address: string, email: string) => Promise<void>;
}) => {
  const { loading, navigateBack, vendor, setVendor } = props;
  const [address, setAddress] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  useEffect(() => {
    setAddress(vendor?.address || "");
    setEmail(vendor?.email || "");
  }, [vendor]);

  return (
    <RightPaneFrame>
      <RightPaneBackButton labelText="Close" onClick={navigateBack} />
      <RightPaneTitle>Edit vendor</RightPaneTitle>

      {loading && <LinearProgress />}

      <Typography level="h4">{vendor?.id || ""}</Typography>

      <FormControl>
        <FormLabel>Address</FormLabel>
        <Textarea
          minRows={3}
          value={address}
          onChange={(event) => {
            setAddress(event.target.value);
          }}
        />
      </FormControl>

      <FormControl>
        <FormLabel>Email</FormLabel>
        <Input
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
      </FormControl>

      <Button
        disabled={address === ""}
        onClick={() => {
          if (address !== "") {
            setVendor(address, email);
          }
        }}
      >
        Store vendor info
      </Button>
    </RightPaneFrame>
  );
};
